import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getShowIdentityUiManagementCenter } from '../selectors';

const ProfileRefreshWrapper = ({
  IdentityUiManagementCenter,
  IdentityUiProfileRefresh,
  showIdentityUiManagementCenter,
  loadStatus,
  location,
  route,
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  if (loadStatus.all !== 'complete') {
    return null;
  }

  // Check for market flag
  return showIdentityUiManagementCenter
    ? <IdentityUiManagementCenter location={location} />
    : <IdentityUiProfileRefresh location={location} route={route} />;
};

ProfileRefreshWrapper.propTypes = {
  IdentityUiManagementCenter: PropTypes.func.isRequired,
  IdentityUiProfileRefresh: PropTypes.node.isRequired,
  showIdentityUiManagementCenter: PropTypes.bool.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export const ComponentToTest = ProfileRefreshWrapper;

const loadDataAsProps = ({ store: { dispatch, getState } }) => ({
  IdentityUiManagementCenter: () => dispatch(queryModuleWithData('identity-ui-management-center')),
  IdentityUiProfileRefresh: () => dispatch(queryModuleWithData('identity-ui-profile-refresh')),
  showIdentityUiManagementCenter: () => ({ status: 'complete', data: getShowIdentityUiManagementCenter(getState()) }),
});

const hocChain = compose(
  oneAppModuleWrapper(ProfileRefreshWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(ProfileRefreshWrapper);
